<template>
  <CJLayout id="app" :class="{ 'knm-code': knmCode }">
    <router-view />
  </CJLayout>
</template>

<script>
import '@/styles/cracker-jack/index.styl'

import bean from 'bean'
import { mapGetters } from 'vuex'

import CJLayout from '@/components/CJLayout'

export default {
  name: 'App',

  components: { CJLayout },

  data () {
    return {
      keys: [ ],
    }
  },

  mounted () {
    this.keyInput = event => this.knmInput(event.keyCode)
    bean.on(window, 'keyup', this.keyInput)
  },

  beforeDestroy () {
    bean.off(window, 'keyup', this.keyInput)
  },

  computed: {
    ...mapGetters([ 'knmCode' ]),
  },

  methods: {
    knmInput (key) {
      clearTimeout(this.keysTimeout)
      this.keys.push(key)
      this.keysTimeout = setTimeout(() => { this.keys = [ ] }, 3000)

      const knmCode = [ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65 ]
      const isValid =
        knmCode.length === this.keys.length &&
        knmCode.every((key, idx) => this.keys[idx] === key)

      if (isValid) {
        this.$store.dispatch('unlockAll')
        this.$router.push({ name: 'game-selection' })
      }
    },
  },
}
</script>

<style lang="stylus">
  @font-face
    font-weight: 700
    font-family: 'Helvetica Neue'
    src: url('assets/HelveticaNeue-Bold.woff2') format('woff2'),
         url('assets/HelveticaNeue-Bold.woff') format('woff')

  @font-face
    font-weight: 700
    font-family: 'Helvetica Neue Condensed'
    src: url('assets/HelveticaNeue-BoldCond.woff2') format('woff2'),
         url('assets/HelveticaNeue-BoldCond.woff') format('woff')

  @font-face
    font-weight: 500
    font-family: 'Futura Std Condensed'
    src: url('assets/FuturaStd-Condensed.woff2') format('woff2'),
         url('assets/FuturaStd-Condensed.woff') format('woff')

  @font-face
    font-weight: 700
    font-family: 'Futura Std Condensed'
    src: url('assets/FuturaStd-CondensedBold.woff2') format('woff2'),
         url('assets/FuturaStd-CondensedBold.woff') format('woff')

  @font-face
    font-weight: 800
    font-family: 'Futura Std Condensed'
    src: url('assets/FuturaStd-CondensedExtraBd.woff2') format('woff2'),
         url('assets/FuturaStd-CondensedExtraBd.woff') format('woff')

  html
  body
    overflow: hidden
    margin: 0
    padding: 0
    width: 100%
    height: 100%
    background-color: black
    color: white
    font: 14px / 1 'Helvetica Neue', Helvetica, Arial, sans-serif

  .candy-bar
    position: absolute
    top: 0
    right: 9px
    left: 9px
    z-index: 1
    display: block
    height: height('assets/base-stripes.png')
    background-image: url('assets/base-stripes.png')
    background-position-x: -11px
    content: ''

    @media screen and (min-device-width: 1024px)
      right: 8px

  .knm-code
    .cj-header
      /* orlosneon ilter: hue-rotate(320deg)*/

      .neon-logo.off
        /*orlosneon filter: invert(1)*/

      .neon-logo.on
        /*orlosneon filter: invert(1) hue-rotate(320deg)*/

    .cj-footer
      /*orlosneon filter: hue-rotate(320deg)*/
</style>
